<template>
  <div id="app">
    <!-- <p>正在加载中</p> -->
    <!-- <Header v-show="getRouteMeta.meta.isShowNav!=1"></Header> -->
    <HeaderV3 v-if="getRouteMeta.meta.isShowNav!=1"/>
    <div class="margin1">
      <router-view v-if="isRouterAlive" />
    </div>
    <FooterV3 v-show="getRouteMeta.meta.isShowNav!=1&&getRouteMeta.meta.isShowFoot!=1"></FooterV3>
	<!-- <FooterV2 v-show="getRouteMeta.meta.isShowNav!=1&&getRouteMeta.meta.isShowFoot!=1"></FooterV2> -->
	<!-- <Footer v-show="getRouteMeta.meta.isShowNav!=1&&getRouteMeta.meta.isShowFoot!=1"></Footer> -->
  </div>
</template>

<script>
import scroll from "@/common/js/scroll.js";
import Header from "@/components/header-v2.vue";
import HeaderV3 from "@/components/header-v3.vue";
import Footer from "@/components/footer.vue";
import FooterV2 from "@/components/footer-v2.vue";
import FooterV3 from "@/components/footer-v3.vue";

export default {
  name: "App",
  metaInfo() {
    return {
      title: this.$store.state.metaModule.metaInfo.title,
      meta: [
        {
          name: "keywords",
          content: this.$store.state.metaModule.metaInfo.keywords
        }, {
          name: "description",
          content: this.$store.state.metaModule.metaInfo.description
        }
      ]
    }
  },
  provide() {
    //依赖注入,用于祖孙组件之间传递 provide与inject配合使用
    return {
      reload: this.reload
    };
  },
  mixins: [scroll],
  components: {
    Header,
    HeaderV3,
    Footer,
    FooterV2,
    FooterV3
  },
  data() {
    return {
      isRouterAlive: true
    };
  },

  created() {

  },
  mounted() {},
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  },
  computed: {
    getRouteMeta() {
      return this.$route;
    }
  }
};
</script>

<style>
@import url("assets/css/reset.css");
@import url("assets/css/common.less");

* {
  margin: 0;
  padding: 0;
  list-style: none;
}

#app {
  /* 抗锯齿渲染 */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

}

.margin1 {
  width: 100%;
  min-height: 600px;
  /* margin-top: 136px; */
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/App.vue